import { ButtonLink } from '@designsforhealth/dfh-react-components'
import styled from 'styled-components'

export const Message = styled.div`
  font-size: 14px;
  line-height: 16.41px;
  border-radius: 8px;
  padding: 11px 15px;
  border: 2px solid;
  margin-bottom: 20px;
  display: flex;
  flex: 1;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: row;
`

export const SuccessMessage = styled(Message)`
  background-color: rgba(71, 194, 177, 0.11);
  color: ${({ theme }) => theme.colors.semantic.success};
  border-color: ${({ theme }) => theme.colors.semantic.success};
`

export const ErrorMessage = styled(Message)`
  background-color: rgba(222, 79, 86, 0.11);
  color: #de4f56;
  border-color: #de4f56;
`

export const Content = styled.div`
  width: 100%;
  p {
    font-size: inherit;
    margin-top: 0;
    margin-bottom: 10px;
  }
`

export const LoginButton = styled(ButtonLink)`
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.component.link};
`

export const ErrorIcon = styled.div`
  align-self: flex-start;
  margin-right: 15px;
`

export const CloseButton = styled.button`
  align-self: flex-start;
  margin: 0 -8px 0 10px;
  padding: 8px;
  border: 0;
  background: none;
  width: 32px;
  cursor: pointer;
`
